<template>
    <div class="feedback-step question--yes-no">
        <!-- <div class="heading-third--grey ">{{ feedbackData.text }}</div> -->
        <div class="heading-third--grey ">{{ feedbackData.text }}</div>
        <QuestionError :showEmptyError="showEmptyError" />
        <div class="scale-buttons">
            <span class="button-ths button-ths--link-pink" :class="[{'selected': scale === 1}]" @click="selectScale(1)">Improved</span>
            <span class="button-ths button-ths--link-pink" :class="[{'selected': scale === 2}]" @click="selectScale(2)">Slight improvement</span>
            <span class="button-ths button-ths--link-pink" :class="[{'selected': scale === 3}]" @click="selectScale(3)">About the same</span>
            <span class="button-ths button-ths--link-pink" :class="[{'selected': scale === 4}]" @click="selectScale(4)">Worse</span>
            <span class="button-ths button-ths--link-pink" :class="[{'selected': scale === 5}]" @click="selectScale(5)">Much worse</span>
        </div>
    </div>
</template>

<script>
    import QuestionError from '@/components/QuestionError.vue'

    export default {
        name: "StepScale",
        props: {
            feedbackData: {
                required: true,
                type: Object,
            },
            savedAnswer: {
                required: true,
            },
            surveyPassingId: {},
            showEmptyError: {
                type: Boolean,
                default: false
            }
        },
        components: {QuestionError},
        data() {
            return {
                scale: '',
                showFeedback: false,
            }
        },
        methods: {
            selectScale(i) {
                /* (i === this.scale) ? this.scale = '' : this.scale = i; */
                if (i === this.scale) {
                    this.scale = '';
                    this.$emit('updateProgress', false);
                }
                else { 
                    this.scale = i;
                    this.$emit('updateProgress', true)
                }
                /* this.$emit('showFeedback', this.scale) */
                this.$emit('hideError')
            }
        }, 
        mounted() {
            if (this.savedAnswer) {
                this.scale = this.savedAnswer.value;
            }
        },
        computed: {
            questionCopy() {
                return 'question.' + this.feedbackData.id
            },
            stepResult() {
                let stepResult = {
                    answer_data: JSON.stringify({value: this.scale}),
                    question_id: this.feedbackData.id,
                };
                if (this.surveyPassingId) {
                    this._lodash.assign(stepResult, {survey_passing_id: this.surveyPassingId});
                }
                return stepResult
            },
            canContinue() {
                return (this.scale === '') ? 0 : 1 ;
            },
            feedbackDataId() {
                return this.feedbackData && this.feedbackData.id;
            },
        },
        watch: {
            savedAnswer() {
                if (this.savedAnswer) {
                    this.scale = this.savedAnswer.value;
                    if (this.scale)
                        this.$emit('showFeedback', this.scale)
                }
                else {
                    this.scale = ''
                }
            },
            feedbackDataId() {
                if (!this.savedAnswer) {
                    this.scale = '';
                }
            }
        },
    }
</script>

<style scoped>

</style>
